<template>
  <div id="box">
    <div id="mainBox">
      <div v-if="isPage == 'index'" class="body">
        <div class="flex">
          <ul class="topBox">
            <li class="flex">
              <div style="width: 240px">
                <el-input v-model="searchVle" placeholder="请输入型号名称"></el-input>
              </div>
            </li>

            <li class="flex" style="padding-top: 5px">
              <el-button type="success" size="small" @click="searchFn">搜索</el-button>
            </li>
          </ul>

          <div class="top_right">
            <el-button type="success" size="small" @click="addFn">新增</el-button>
            <el-button type="warning" size="small" @click="returnFn">返回</el-button>
          </div>
        </div>

        <!-- 主体内容 -->
        <div>
          <el-table :data="tableData" border style="width: 100%; margin-top: 10px">
            <el-table-column align="center" label="型号图片">
              <template slot-scope="scope">
                <div class="goodsImg">
                  <img style="width: 50px" :src="scope.row.images" alt="" srcset="" />
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="name" align="center" label="型号名称">
            </el-table-column>

            <el-table-column prop="name2" align="center" label="关键词匹配">
            </el-table-column>

            <el-table-column prop="englishName" align="center" label="英文名称">
            </el-table-column>

            <el-table-column
              prop="englishName"
              width="200px"
              align="center"
              label="标准图谱(无坐标)"
            >
              <template slot-scope="scope">
                <div class="goodsImg">
                  <img
                    style="width: 50px"
                    @click="previewFn(scope.row.atlas1)"
                    :src="scope.row.atlas1"
                    alt=""
                    srcset=""
                  />
                </div>
              </template>
            </el-table-column>

            <el-table-column
              prop="englishName"
              width="200px"
              align="center"
              label="标准图谱(有坐标)"
            >
              <template slot-scope="scope">
                <div class="goodsImg">
                  <img
                    style="width: 50px"
                    @click="previewFn(scope.row.atlas2)"
                    :src="scope.row.atlas2"
                    alt=""
                    srcset=""
                  />
                </div>
              </template>
            </el-table-column>

            <el-table-column align="center" label="容量管理">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="capacityFn(scope.row)"
                  >管理</el-button
                >
              </template>
            </el-table-column>

            <el-table-column prop="bzyc" align="center" label="标准乙醇">
            </el-table-column>

            <el-table-column prop="extraJbCost" align="center" label="附收鉴别费(元)">
            </el-table-column>

            <el-table-column width="180" align="center" label="操作">
              <template slot-scope="scope">
                <el-button type="success" size="small" @click="editFn(scope.$index)"
                  >编辑</el-button
                >
                <el-button type="danger" size="small" @click="delFn(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <div class="page_box">
            <el-pagination
              @current-change="changePage"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              layout="total, prev, pager, next,jumper"
              :total="tableTotal"
            >
            </el-pagination>
          </div>
        </div>
        <!-- 主体内容 -->
      </div>

      <!-- 发货 -->
      <div class="excellent_box" v-if="excellenShow == 1">
        <div class="excellent_main">
          <div class="excellent_top">
            新增型号
            <i class="el-icon-close" @click.stop="closeFn"></i>
          </div>

          <div class="excellent_content">
            <div class="excellent_li">
              <span>型号图片：</span>
              <div style="width: 290px">
                <div style="width: 100px; height: 100px">
                  <elUpload @getImg="getImgFn" :image="addList.images"></elUpload>
                </div>
              </div>
            </div>

            <div class="excellent_li">
              <span>标准谱图：</span>
              <div style="width: 290px">
                <div class="imgLi">
                  <div style="height: 100px">
                    <elUpload @getImg="getImgFn2" :image="addList.atlas1"></elUpload>
                  </div>
                  <div class="imgLi_text">无坐标</div>
                </div>

                <div class="imgLi">
                  <div style="height: 100px">
                    <elUpload @getImg="getImgFn3" :image="addList.atlas2"></elUpload>
                  </div>
                  <div class="imgLi_text">有坐标</div>
                </div>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>型号名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.name"
                  placeholder="请填型号名称"
                ></el-input>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>关键词匹配：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.name2"
                  placeholder="请填型号名称"
                ></el-input>
              </div>
            </div>

            <div class="excellent_li flex">
              <span>英文名称：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.englishName"
                  placeholder="请填写英文名称"
                ></el-input>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>标准乙醇：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.bzyc"
                  placeholder="请填写英文名称"
                ></el-input>
              </div>
            </div>
            <div class="excellent_li flex">
              <span>额外鉴别金额：</span>
              <div style="width: 290px">
                <el-input
                  size="medium"
                  v-model="addList.extraJbCost"
                  placeholder="请填写金额"
                ></el-input>
              </div>
            </div>

            <div class="excellent_btn flex">
              <el-button type="success" size="small" @click.stop="excellentFn"
                >提交</el-button
              >
              <el-button type="info" size="small" @click.stop="closeFn">取消</el-button>
            </div>
          </div>
        </div>
      </div>

      <!--容量管理 -->
      <popupBox title="容量管理" v-if="isCapacity">
        <div class="popupMain">
          <div class="popupLi flex" v-for="(item, index) in capacityArr">
            <div class="capacityLi flex">
              <span class="capacityLi_text">容量</span>
              <input type="text" v-model="item.ml" placeholder="请输入" />
              <span class="capacityLi_text">ml</span>
            </div>

            <!-- <div class="capacityLi flex">
              <span class="capacityLi_text">专柜价</span>
              <input type="text" v-model="item.price" placeholder="请输入" />
              <span class="capacityLi_text">元</span>
            </div> -->
          </div>
        </div>

        <div class="popupBtn flex">
          <el-button type="success" size="small" @click="confirmCapacityFn"
            >确认</el-button
          >
          <el-button type="info" size="small" @click="closeCapacityFn">取消</el-button>
        </div>
      </popupBox>
      <!-- 容量管理 -->
    </div>
  </div>
</template>

<script>
import { delTips, returnTime, throttle, isJSON } from "@/util/utils";
import elUpload from "@/components/elUpload";
import popupBox from "@/components/popupBox";

export default {
  components: {
    elUpload,
    popupBox,
  },
  props: {
    dataList: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      isPage: "index",

      surplusShow: 0,
      userList: "",

      // 历史记录
      historyArr: ["用户管理"],

      //  搜索
      searchVle: "",

      // 品牌
      excellenShow: 0,

      // 添加数据
      addList: {
        name: "",
        name2: "",
        englishName: "",
        images: "",
        atlas1: "",
        atlas2: "",
        capacity: "",
      },

      // 列表数据
      tempList: {},

      // 容量
      isCapacity: false,
      capacityArr: [],
      tempCapacity: [
        { ml: "", price: "" },
        { ml: "", price: "" },
        { ml: "", price: "" },
        { ml: "", price: "" },
        { ml: "", price: "" },
      ],

      // 数据信息
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      tableTotal: 0,
    };
  },
  mounted() {
    this.selListFn(1);
  },
  methods: {
    // 搜索
    searchFn: function (res) {
      this.selListFn(1);
      this.currentPage = 1;
    },

    // 新增
    addFn() {
      this.addList = {
        name: "",
        name2: "",
        englishName: "",
        images: "",
      };
      this.excellenShow = 1;
    },

    // 编辑
    editFn: function (index) {
      var list = this.tableData[index];
      this.addList = list;
      this.excellenShow = 1;
    },

    closeFn: function () {
      this.excellenShow = 0;
      this.pageChangeShow = 1;
      this.selListFn(this.currentPage);
    },

    // 打开容量
    capacityFn(list) {
      this.isCapacity = true;
      this.tempList = list;

      if (list.capacity) {
        this.capacityArr = isJSON(list.capacity)
          ? JSON.parse(list.capacity)
          : list.capacity;
      } else {
        this.capacityArr = JSON.parse(JSON.stringify(this.tempCapacity));
      }
    },

    // 图片上传
    getImgFn: function (res) {
      this.$set(this.addList, "images", res);
    },

    // 图片上传
    getImgFn2: function (res) {
      this.$set(this.addList, "atlas1", res);
    },

    // 图片上传
    getImgFn3: function (res) {
      this.$set(this.addList, "atlas2", res);
    },

    // 提交
    confirmCapacityFn: throttle(function () {
      let arr = JSON.parse(JSON.stringify(this.capacityArr));

      let isCapacity = false;
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].ml) {
          isCapacity = true;
          break;
        }
      }

      if (!isCapacity) {
        this.$message.error("至少填写一个容量信息");
        return;
      }

      let list = this.tempList;
      var obj = {
        id: list.id,
      };

      let urls = this.$api.api.upModel;
      obj.capacity = JSON.stringify(arr);

      // return
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.closeCapacityFn();
          this.selListFn(this.currentPage);
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    //取消
    closeCapacityFn() {
      this.isCapacity = false;
    },

    excellentFn: throttle(function () {
      var data = this.addList;
      if (!data.images) {
        this.$message.error("请上传图片");
        return;
      }

      // if (!data.atlas1) {
      //   this.$message.error("请上传图谱");
      //   return;
      // }

      // if (!data.atlas2) {
      //   this.$message.error("请上传图谱");
      //   return;
      // }
      if (!data.name) {
        this.$message.error("请输入品牌名称");
        return;
      }
      if (!data.name2) {
        this.$message.error("请输入关键词匹配");
        return;
      }
      if (!data.englishName) {
        this.$message.error("请输入英文名称");
        return;
      }
      if (!data.bzyc) {
        this.$message.error("请输入标准乙醇");
        return;
      }
      var obj = {
        atlas1: data.atlas1,
        atlas2: data.atlas2,
        images: data.images,
        name: data.name,
        name2: data.name2,
        englishName: data.englishName,
        bzyc: data.bzyc,
        extraJbCost: data.extraJbCost,
        brandId: this.dataList.id,
      };

      let urls = this.$api.api.addModel;
      if (data.id) {
        urls = this.$api.api.upModel;
        obj.id = data.id;
      }

      // return
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
          this.closeFn();
        } else {
          this.$message.error("操作失败");
        }
      });
    }),

    // 查询
    selListFn: function (page) {
      var obj = {
        page: page,
        size: this.pageSize,
        brandId: this.dataList.id,
      };

      if (this.searchVle) {
        obj.name = this.searchVle;
      }

      this.$https(this.$api.api.selModel, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          this.tableData = data;
          this.tableTotal = res.data.size;
        } else {
          this.tableData = [];
          this.tableTotal = 0;
        }
      });
    },

    // 返回
    returnFn(res) {
      this.$emit("return", {});
    },

    // 分页
    changePage: function (res) {
      this.selListFn(res);
    },

    // 删除
    delFn: delTips(function (index) {
      var list = this.tableData[index];

      this.$https(
        this.$api.api.delType,
        {
          id: list.id,
        },
        "GET"
      ).then((res) => {
        if (res.data.code == 200) {
          this.selListFn(this.currentPage);
          this.$message.success("操作成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    }),
  },
};
</script>

<style lang="less" scoped>
#box {
  width: 100%;

  .body {
    margin-top: 20px;
  }

  .top_right {
    display: flex;
  }

  .topBox {
    width: 100%;
    margin-top: 10px;
    overflow: hidden;
    font-size: 15px;

    li {
      float: left;
      margin-right: 20px;
      margin-bottom: 10px;

      .el-range-editor.el-input__inner {
        width: 290px;
      }
    }

    li:last-child {
      margin-right: 0px;
    }

    span {
      margin-right: 5px;
    }
  }
}

// 新增品牌
.excellent_box {
  width: 100%;
  height: 100vh;
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  background: rgba(000, 000, 000, 0.5);

  .excellent_main {
    width: 600px;
    height: 900px;
    margin: auto;
    background: #fff;
    transform: translate(-50%, -50%);
    position: fixed;
    left: 50%;
    top: 50%;
    border-radius: 5px;
    overflow: hidden;

    .excellent_top {
      width: 96%;
      height: 40px;
      background: #eee;
      line-height: 40px;
      padding: 5px 2%;
      font-size: 15px;

      i {
        float: right;
        margin-top: 10px;
        font-size: 20px;
        cursor: pointer;
      }
    }

    .excellent_content {
      width: 100%;
      margin-top: 10px;

      .excellent_li {
        margin-top: 25px;
        display: flex;

        .el-select {
          width: 100%;
        }

        .imgLi {
          width: 100%;
          margin-bottom: 20px;

          .imgLi_text {
            text-align: center;
            margin-top: 5px;
          }
        }

        span {
          width: 120px;
          display: inline-block;
          flex-shrink: 0;
          text-align: right;
        }
      }

      .excellent_btn {
        justify-content: flex-end;
        margin: 25px 15px 0px 0px;
      }
    }
  }
}

// 新增品牌

//弹框数据

.popupMain {
  width: 100%;
  padding: 5px 10px;
  box-sizing: border-box;

  .popupLi {
    width: 100%;
    height: 40px;
    justify-content: space-between;
    margin-top: 10px;

    .capacityLi {
      width: 49%;
      height: 38px;
      font-size: 13px;
      color: #666;
      padding: 4px 5px;
      box-sizing: border-box;
      border: 1px solid #eee;
      border-radius: 5px;

      .capacityLi_text {
        flex-shrink: 0;
      }

      input {
        width: 100%;
        height: 100%;
        border: 0;
        margin: 0px 3px;
        text-align: center;
      }
    }
  }
}

.popupBtn {
  justify-content: flex-end;
  margin: 10px auto auto auto;

  .popupBtnLi {
    cursor: pointer;
    margin-right: 6px;
  }
}

// 弹框数据
</style>



// WEBPACK FOOTER //
// src/pages/brand/model.vue